import 'dayjs/locale/en-gb';
import { SidebarLayer } from './Layers/SidebarLayer';
import { HeaderLayer } from './Layers/HeaderLayer';
import { GridLayer } from './Layers/GridLayer';
import { EventLayer } from './Layers/EventLayer';
import dayjs, { type Dayjs } from 'dayjs';
import { Stack } from '@mantine/core';

import 'dayjs/locale/cs';
import { MonthSelector } from '../MonthSelector/MonthSelector';

dayjs.locale('cs');

export interface CalendarEvent {
  start: string;
  end: string;
  color: string;
  label: string;
  tooltip?: string;
  onClick?: () => void;
}

export interface CalendarDay {
  date: string;
  events: CalendarEvent[];
}

interface Props {
  days: CalendarDay[];
  month: Dayjs;
  setMonth?: (month: Dayjs) => void;
  width?: string;
  dateFormat?: string;
  rowHeight?: number;
}

export const Calendar = (props: Props) => {
  const {
    width = '100%',
    month,
    setMonth,
    dateFormat = 'DD.MM',
    rowHeight = 30,
    days,
  } = props;

  if (days.length === 0) {
    return (
      <div>
        Vybraný klient nemá v tomto měsíci pro vybranou službu žádné úkoly.
      </div>
    );
  }

  const startDate = month.startOf('month');

  return (
    <Stack className="w-full">
      {setMonth && <MonthSelector value={startDate} setValue={setMonth} />}
      <div style={{ width }} className="flex flex-row h-full">
        <SidebarLayer days={days} rowHeight={rowHeight} format={dateFormat} />
        <div className="flex flex-col w-full">
          <HeaderLayer height={rowHeight} />
          <div className="flex relative w-full">
            <GridLayer days={days} height={rowHeight} />
            <EventLayer
              startDate={startDate}
              days={days}
              rowHeight={rowHeight}
            />
          </div>
        </div>
      </div>
    </Stack>
  );
};
